import BaseService from "./BaseService";
import http from "./HttpService";
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/match";

export default class MatchesService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}

	create = (type, data) => {
		return http.post(`${apiEndpoint}/${type}`, data);
	};

	update = (type, id, data) => {
		return http.put(`${apiEndpoint}/${type}/${id}`, data);
	};

	remove = (type, id) => {
		return http.delete(`${apiEndpoint}/${type}/${id}`);
	};

	getList = (type, params) => {
		return http.get(`${apiEndpoint}/${type}`, { params });
	};

	find = (type, id) => {
		return http.get(`${apiEndpoint}/${type}/${id}`);
	};

	changePin = (type, id) => {
		return http.put(`${apiEndpoint}/${type}/${id}`);
	};
}
